import Vue from 'vue'
import Router from 'vue-router'

const index = (resolve) => {
  import('@/views/index').then((module) => {
    resolve(module)
  }).catch(err => {
    console.log(err)
  })
}
const detail = (resolve) => {
  import('@/views/detail').then((module) => {
    resolve(module)
  }).catch(err => {
    console.log(err)
  })
}
const position = (resolve) => {
  import('@/views/position').then((module) => {
    resolve(module)
  }).catch(err => {
    console.log(err)
  })
}
const connect = (resolve) => {
  import('@/views/connect').then((module) => {
    resolve(module)
  }).catch(err => {
    console.log(err)
  })
}
const plan = (resolve) => {
  import('@/views/plan').then((module) => {
    resolve(module)
  }).catch(err => {
    console.log(err)
  })
}
const user = (resolve) => {
  import('@/views/user').then((module) => {
    resolve(module)
  }).catch(err => {
    console.log(err)
  })
}

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      component: index
    },
    {
      path: '/detail',
      component: detail
    },
    {
      path: '/position',
      component: position
    },
    {
      path: '/connect',
      component: connect
    },
    {
      path: '/plan',
      component: plan
    },
    {
      path: '/user',
      component: user
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js